import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, combineLatest, firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { commonState_IsAdviserElevatedAccess, commonState_IsFundElevatedAccess } from '../store/common/common.selectors';
import { Helper } from '@ifaa-components/ui-components';

@Injectable({
    providedIn: 'root'
})
export class AuthHelperService {
    private logoutInProgressSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    isElevatedAccess$ = this.store.pipe(select(commonState_IsFundElevatedAccess));
    isAdviserElevatedAccess$ = this.store.pipe(select(commonState_IsAdviserElevatedAccess));

    isElevated: boolean = false;
    helper: Helper = new Helper();

    constructor(private msalService: MsalService, private store: Store) { }

    // only call logout redirect if it hasnt been triggered before
    async logoutRedirect(): Promise<void> {
        const isInProgress = await firstValueFrom(this.logoutInProgressSubject);
        if (isInProgress) {
            return;
        }
        return await this.logoutRedirectSafe();
    }

    private async logoutRedirectSafe() {
        this.setLogoutInProgress(true);

        var elevated = false;

        var subscription = combineLatest([this.isElevatedAccess$, this.isAdviserElevatedAccess$])
            .subscribe(([isElevated, isAdviser]) => {
                elevated = isElevated || isAdviser;
            })

        if (!elevated) {
            // logout with redirect
            await this.msalService.logoutRedirect({
                postLogoutRedirectUri: environment.b2cLogoutUrl,
            });
        } else {
            // logout without redirect
            await this.msalService.logout({
                onRedirectNavigate: () => {
                    return false;
                }
            });
            
            window.parent.postMessage({
                type: 'elevatedLogout',
            }, '*');
        }

        subscription.unsubscribe();
    }

    private setLogoutInProgress(inProgress: boolean): void {
        this.logoutInProgressSubject.next(inProgress);
    }
}